import { Avatar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";

const Profile = () => {
  const userProfile = useSelector((state) => state.auth.main);
  const classes = useStyles();

  function getInicials(text) {
    return text
      ?.split(" ")
      .map((i) => i[0])
      .join("");
  }

  return (
    <div className={classes.root}>
      <Avatar alt="Person" className={classes.avatar} component={RouterLink} to="/settings">
        {getInicials(userProfile.name)}
      </Avatar>
      <Typography className={classes.name} variant="h4">
        {userProfile.name}
      </Typography>
      <Typography variant="body2">{userProfile.role}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content"
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

export default Profile;
